module.exports = __webpack_public_path__ + "static/media/loplat-manager.057c3a9d.svg";